export default __webpack_public_path__ + "static/media/Ma009-2.f1bb8468.svg";